var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotMutedInstrument = function SvgNotMutedInstrument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.7 7.084.006-.006.006-.005c.19-.206.31-.304.394-.354a.342.342 0 0 1 .194-.052c.09 0 .16.034.218.1a.553.553 0 0 1 .12.365v12.782c0 .16-.054.27-.11.33a.272.272 0 0 1-.212.093c-.14 0-.295-.036-.61-.37l-.003-.004-3.172-3.297-.011-.012-.011-.01a.904.904 0 0 0-.632-.258H7.73c-.422 0-.65-.124-.786-.278-.148-.17-.279-.485-.279-1.04v-3.115c0-.556.131-.87.28-1.04.134-.155.363-.278.785-.278h2.147a.894.894 0 0 0 .657-.284l3.167-3.267Z",
    stroke: "currentColor",
    strokeWidth: 1.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.1c.448.399.7.938.7 1.5 0 .563-.252 1.103-.7 1.5M18.4 10a5.04 5.04 0 0 1 1.4 3.5 5.04 5.04 0 0 1-1.4 3.5",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNotMutedInstrument;